import path from "path";
import {Asset, AssetType} from "../../redux/assets-slice";
import {fse} from "../../electron-modules";
import {isModelFile, isRawPointsFile, isStreamablePointsFile} from "../utils/misc";
import {
  moveCameraData,
  moveModelData,
  moveRawPointCloud,
  moveStreamablePointsData
} from "./utils";
import { PythonExecutable } from "../../executable";
import { asyncTimeout } from "../../utilities";

const assetsFolder = "assets";
const processTimeout = 1000;

const getAssetIndex = (state, asset) => {
  const assetIds = state.assets.map(x => x.id);
  return assetIds.indexOf(asset.id);
};

export const updateCameraDataState = (asset, state) => {
  const assetIndex = getAssetIndex(state, asset);
  const imagesData = asset.data;
  imagesData.forEach((imageData, imageIndex) => {
    const imageName = path.basename(imageData.path);
    const finalPath = path.join(assetsFolder, asset.id, imageName);
    state.assets[assetIndex].data[imageIndex].path = `./${finalPath}`;
  });
};

export const updateModelDataState = (asset, state) => {
  const assetIndex = getAssetIndex(state, asset);
  const modelName = path.basename(asset.path);
  const finalPath = path.join(assetsFolder, asset.id, modelName);
  state.assets[assetIndex].path = `./${finalPath}`;
};

export const updateStreamablePointsState = (asset, state) => {
  const assetIndex = getAssetIndex(state, asset);
  const finalPath = path.join(assetsFolder, asset.id);
  state.assets[assetIndex].path = `./${finalPath}`;
};

export const updateRawPointsState = (asset, state, singleFileOutput) => {
  const assetIndex = getAssetIndex(state, asset);

  const finalPath = singleFileOutput
    ? path.join(assetsFolder, asset.id)
    : path.join(assetsFolder, asset.id, "points");

  state.assets[assetIndex].path = `./${finalPath}`;
  state.assets[assetIndex].type = singleFileOutput
    ? AssetType.Potree
    : AssetType.Encompass;
};

export const updateCameraTransformPath = (state, outputPath) => {
  const dataPath = path.join(outputPath, assetsFolder);

  const outputName = "camera.4x4";
  const matrixPath = state.camera.transform;
  const newImagePath = path.join(dataPath, outputName);

  if (matrixPath) {
    fse.copy(matrixPath, newImagePath);
    const finalPath = path.join(assetsFolder, outputName);
    state.camera.transform = `./${finalPath}`;
  }
};

export const moveAssetData = async (asset: Asset, outputPath: string,
  exe: PythonExecutable, onLogs, singleFileOutput, handleExportError) => {
  const dataPath = path.join(outputPath, assetsFolder);

  if (isStreamablePointsFile(asset)) {
    await moveStreamablePointsData(asset, dataPath, exe);
  } else if (isRawPointsFile(asset)) {
    await moveRawPointCloud(asset, dataPath, exe, onLogs, singleFileOutput);
  } else if (asset.type === AssetType.Panoramic) {
    await moveCameraData(asset, dataPath);
  } else if (asset.type === AssetType.Planar) {
    await moveCameraData(asset, dataPath);
  } else if (isModelFile(asset)) {
    await moveModelData(asset, dataPath, handleExportError);
  }

  await asyncTimeout(processTimeout);
};